const formatUTCDate = (value) => {
  if (!value) return "N/A";

  const fechaUTC = new Date(value);

  if (Number.isNaN(fechaUTC.getTime())) return value;

  return `${fechaUTC.getUTCFullYear()}-${String(
    fechaUTC.getUTCMonth() + 1
  ).padStart(2, "0")}-${String(fechaUTC.getUTCDate()).padStart(2, "0")} ${String(
    fechaUTC.getUTCHours()
  ).padStart(2, "0")}:${String(fechaUTC.getUTCMinutes()).padStart(
    2,
    "0"
  )}:${String(fechaUTC.getUTCSeconds()).padStart(2, "0")}`;
};

const columns = [
  { field: "id", headerName: "ID", width: 90 },
  { field: "tipoMaquinaControl", headerName: "Tipo de Máquina y Control", minWidth: 220, flex: 1 },
  { field: "numeroEquipo", headerName: "Número de Equipo", minWidth: 160, flex: 1 },
  { field: "fecha", headerName: "Fecha", minWidth: 180, flex: 1 },
  { field: "tempEvaporadorSalida", headerName: "Temp Evaporador Salida", minWidth: 200, flex: 1 },
  { field: "tempEvaporadorEntrada", headerName: "Temp Evaporador Entrada", minWidth: 200, flex: 1 },
  { field: "presionSuccion", headerName: "Presión Succión", minWidth: 180, flex: 1 },
  { field: "presionDescarga", headerName: "Presión Descarga", minWidth: 180, flex: 1 },
  { field: "sobrecalentamiento", headerName: "Sobrecalentamiento", minWidth: 180, flex: 1 },
  { field: "tempSuccion", headerName: "Temp Succión", minWidth: 160, flex: 1 },
  { field: "vdcVentiladorEcC1", headerName: "VDC Ventilador EC C1", minWidth: 190, flex: 1 },
  { field: "condicionActual", headerName: "Condición Actual", minWidth: 200, flex: 1 },
  { field: "proteccionVentiladorMotorC1", headerName: "Protección Ventilador y Motor C1", minWidth: 260, flex: 1 },
  { field: "proteccionBajaPresionExvC1", headerName: "Protección Baja Presión y EXV C1", minWidth: 280, flex: 1 },
  { field: "switchFlujoAguaHelada", headerName: "Switch Flujo Agua Helada", minWidth: 220, flex: 1 },
  { field: "encendidoCompresor1", headerName: "Encendido Compresor 1", minWidth: 200, flex: 1 },
  { field: "activaExvC1", headerName: "Activa EXV C1", minWidth: 180, flex: 1 },
  { field: "ventilador1C1Ec", headerName: "Ventilador 1 C1 EC", minWidth: 180, flex: 1 },
  { field: "ventilador2C1Ac", headerName: "Ventilador 2 C1 AC", minWidth: 180, flex: 1 },
  { field: "fechaFalla1", headerName: "Fecha de Falla 1", minWidth: 180, flex: 1 },
  { field: "numFalla1", headerName: "Num Falla 1", minWidth: 220, flex: 1 },
  { field: "fechaFalla2", headerName: "Fecha de Falla 2", minWidth: 180, flex: 1 },
  { field: "numFalla2", headerName: "Num Falla 2", minWidth: 220, flex: 1 },
  { field: "fechaFalla3", headerName: "Fecha de Falla 3", minWidth: 180, flex: 1 },
  { field: "numFalla3", headerName: "Num Falla 3", minWidth: 220, flex: 1 },
  { field: "fechaFalla4", headerName: "Fecha de Falla 4", minWidth: 180, flex: 1 },
  { field: "numFalla4", headerName: "Num Falla 4", minWidth: 220, flex: 1 },
  { field: "fechaFalla5", headerName: "Fecha de Falla 5", minWidth: 180, flex: 1 },
  { field: "numFalla5", headerName: "Num Falla 5", minWidth: 220, flex: 1 },
  { field: "tiempoServicioHoras", headerName: "Tiempo de Servicio en Horas", minWidth: 220, flex: 1 },
  { field: "horasTotalesOperacion", headerName: "Horas Totales de Operación", minWidth: 220, flex: 1 },
];

const mapRow = (row, index) => ({
  id: index + 1,
  tipoMaquinaControl: row["Tipo de Máquina y Control"],
  numeroEquipo: row["Número de Equipo"],
  fecha: formatUTCDate(row["Fecha"]),
  tempEvaporadorSalida: row["Temp Evaporador Salida"],
  tempEvaporadorEntrada: row["Temp Evaporador Entrada"],
  presionSuccion: row["Presión Succión"],
  presionDescarga: row["Presión Descarga"],
  sobrecalentamiento: row["Sobrecalentamiento"],
  tempSuccion: row["Temp Succión"],
  vdcVentiladorEcC1: row["VDC Ventilador EC C1"],
  condicionActual: row["Condición Actual"],
  proteccionVentiladorMotorC1: row["Protección Ventilador y Motor C1"],
  proteccionBajaPresionExvC1: row["Protección Baja Presión y EXV C1"],
  switchFlujoAguaHelada: row["Switch Flujo Agua Helada"],
  encendidoCompresor1: row["Encendido Compresor 1"],
  activaExvC1: row["Activa EXV C1"],
  ventilador1C1Ec: row["Ventilador 1 C1 EC"],
  ventilador2C1Ac: row["Ventilador 2 C1 AC"],
  fechaFalla1: formatUTCDate(row["Fecha de Falla 1"]),
  numFalla1: row["Num Falla 1"] || "N/A",
  fechaFalla2: formatUTCDate(row["Fecha de Falla 2"]),
  numFalla2: row["Num Falla 2"] || "N/A",
  fechaFalla3: formatUTCDate(row["Fecha de Falla 3"]),
  numFalla3: row["Num Falla 3"] || "N/A",
  fechaFalla4: formatUTCDate(row["Fecha de Falla 4"]),
  numFalla4: row["Num Falla 4"] || "N/A",
  fechaFalla5: formatUTCDate(row["Fecha de Falla 5"]),
  numFalla5: row["Num Falla 5"] || "N/A",
  tiempoServicioHoras: row["Tiempo de Servicio en Horas"],
  horasTotalesOperacion: row["Horas Totales de Operación"],
});

export const fullServiceCoolingV3_1CompConsultaConfig = {
  title: "Full Service Cooling V3 1Comp",
  endpoint:
    "https://lndvjnxrzb.execute-api.us-east-2.amazonaws.com/test/consulta/fullservicecoolingv31comp/datos",
  buildRequestBody: ({ idEquipo, fechaInicio, fechaFinal }) => ({
    idEquipo,
    fechaInicio,
    fechaFinal,
    tipoMaquina: "Full Service Cooling V3 1Comp",
    tipoConsulta: "Datos",
  }),
  columns,
  mapRow,
};